// Хвост для прочих ссылок перехода
export const closingTransitionlinkForOtherLinks =
  's_trk={TR_KEY}&erid={ERID}' as const;
